import { useSelector } from "react-redux";
const { FormatMoney } = require("format-money-js");

export const Balance = () => {
    const { transactions } = useSelector((state) => state.transaction) || [];

    const fm = new FormatMoney({
        decimals: 0,
    });

    // balance caculation
    let balance = 0;
    transactions.forEach((transaction) => {
        if (transaction.type === "income") {
            balance += transaction.amount;
        } else if (transaction.type === "expanse") {
            balance -= transaction.amount;
        }
    });
    return (
        <>
            <div className="bg-blue-700 md:w-4/12 mx-auto p-4 rounded-t">
                <p className="text-sm text-white">Your Current Balance:</p>
                <h2 className="text-2xl font-bold text-white">
                    &#2547; {fm.from(balance)}
                </h2>
            </div>
        </>
    );
};
